<template>
    <div class="block-promo" id="block-promo">
        <BlockParallax class="block-promo__icon block-promo--heart-1" speed="15">
            <img src="@/assets/images/icons/1517-heart.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--heart-2" speed="18">
            <img src="@/assets/images/icons/1517-heart.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--heart-3" speed="16">
            <img src="@/assets/images/icons/1517-heart.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--heart-4 block-promo--icon-desktop" speed="14">
            <img src="@/assets/images/icons/1517-heart.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--book" speed="9" direction="left">
            <img src="@/assets/images/icons/1517-book.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--cup" speed="10">
            <img src="@/assets/images/icons/1517-cup.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--clock block-promo--icon-desktop" speed="7">
            <img src="@/assets/images/icons/1517-clock.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--clock-2" speed="8" direction="left">
            <img src="@/assets/images/icons/1517-clock.png">
        </BlockParallax>
        <div class="main-wrap">
            <div class="block-promo__content">
                <p class="block-promo__title">15-17</p>
                <p class="block-promo__text">
                    Наконец, начало самостоятельной жизни, выбор&nbsp;профессии, поступление и&nbsp;первая&nbsp;любовь.
                </p>
                <icon-arrow class="block-promo__arrow" v-scroll-to="'#block-info-five'" />
            </div>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>


<style scoped lang="stylus">
    .block-promo {
        position relative
        background-color #328ec6
        overflow hidden
        background-image url('~@/assets/images/icons/1517-path-m-1.svg'),
        url('~@/assets/images/icons/1517-path-m-2.svg'),
        url('~@/assets/images/icons/1517-path-m-3.svg')
        background-repeat no-repeat
        background-position bottom left, bottom right, top right
        background-size 10rem, 9rem, 8rem
        +layout-md-and-up() {
            position relative
            background-image url("~@/assets/images/icons/1517-path-1.svg")
            ,url('~@/assets/images/icons/1517-path-2.svg')
            ,url("~@/assets/images/icons/1517-path-3.svg")
            ,url("~@/assets/images/icons/1517-path-4.svg")
            background-position left 11% bottom, right 17% top, left 24.5% top, right 15.5% top
            background-size contain, contain, contain, contain
        }

        &__content {
            position relative
            +layout-md-and-up() {
                display flex
                flex-direction column
                align-items center
                padding-bottom 5rem
            }
        }

        &__title {
            font-size 5.6rem
            color #FFFFFF
            font-weight 900
            letter-spacing 0.61px
            margin 2.7rem 0 0
            padding 0 0 0 5rem

            +layout-sm-and-up() {
                text-align center
                padding 0
            }
            +layout-md-and-up() {
                font-size 8rem
                letter-spacing 0.87px
                margin 12rem 0 0
                padding 0
            }
        }

        &__text {
            box-sizing border-box
            margin 0
            padding 2rem 3rem 13rem 5rem
            font-size 1.5rem
            line-height 1.47
            color #fff

            +layout-sm-and-up() {
                text-align center
                font-size 1.8rem
                line-height 2.8rem
                letter-spacing 0.19px
            }
            +layout-md-and-up() {
                width 100%
                max-width 45rem
                padding-bottom 0
                padding-top 2.1rem
            }
        }

        &__icon {
            position absolute
            max-width 100%
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &--book {
            width 7.8rem
            bottom 12rem
            left -2.8rem
            transform rotate(-80deg)
            +layout-md-and-up() {
                width 14rem
                left 32.8rem
                bottom 12rem
                img {
                    transform rotate(60deg)
                }
            }
        }
        &--cup {
            top 5.2rem
            right 2.5rem
            width 5rem
            transform rotate(45deg)
            +layout-md-and-up() {
                top 5.5rem
                right 37rem
                width 10.5rem
                img {
                    transform rotate(120deg)
                }
            }
        }

        &--clock {
            left .5%
            top 3.5rem
            transform rotate(-40deg)
            width 5.5rem
            +layout-md-and-up() {
                left 6rem
                top 14rem
                width 9rem
                img {
                    transform rotate(100deg)
                }
            }
        }
        &--clock-2 {
            width 5.2rem
            bottom 4rem
            right 6.3rem
            transform rotate(-20deg)
            +layout-md-and-up() {
                width 11rem
                right 13.3rem
                bottom 6rem
                img {
                    transform rotate(-50deg)
                }
            }
        }

        &--heart-1 {
            bottom 3rem
            left 0
            right 4rem
            width 2.5rem
            margin auto
            +layout-md-and-up() {
                bottom 13rem
                left 19.5rem
                right auto
                margin 0
                img {
                    transform rotate(-105deg)
                }
            }
        }
        &--heart-2 {
            left 1.2rem
            top 8px
            width 2.5rem
            transform rotate(-70deg)
            +layout-md-and-up() {
                top 5.9rem
                left 42.5rem
                img {
                    transform rotate(155deg)
                }
            }
        }
        &--heart-3 {
            right 2.1rem
            bottom 13rem
            width 2.5rem
            transform rotate(110deg)
            +layout-md-and-up() {
                bottom 19.4rem
                right 37rem
                img {
                    transform rotate(100deg)
                }
            }
        }
        &--heart-4 {
            +layout-md-and-up() {
                top 13.3rem
                right 17.7rem
                img {
                    transform rotate(-170deg)
                }
            }
        }

        &__arrow {
            width 2rem
            position absolute
            right 0.6rem
            bottom 2rem
            animation translate 1.5s linear infinite forwards

            +layout-md-and-up() {
                position static
                padding-top 0
                margin-top 2rem
                padding-bottom 8.5rem
                cursor pointer

                &:hover {
                    fill $color-blue
                    cursor pointer
                    animation-play-state paused
                    opacity 0.7
                }
            }
        }
    }
</style>
